//export * from './model';

import type { ReportsComponentProps } from './ReportsComponent';

export const ReportsComponent = {
    MountAsync: async (target: HTMLElement, props: ReportsComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { ReportsComponent } = await import('./ReportsComponent');
        return await mountReactComponentAsync(target, ReportsComponent, props);
    }
};